import React from 'react';
import PropTypes from 'prop-types';
import {Popup} from 'semantic-ui-react';

import {CLIENT, ENCODING_TARGET} from '@constants/resources';
import {SECURITY_PRIVILEGES_READ_UPDATE, SECURITY_PRIVILEGES_UPDATE} from '@constants/variables';
import {IconDelete} from '@appComponents/IconCollection';
import {columnObjectAlignCenter, columnObjectAlignLeft, TunnelStatus} from '@utils/tableHelpers';
import {
    parseTunnelerData,
    renderTunnelerLink,
    showDeleteThirdPartyTunnelerModal,
} from '@modules/events/utils/eventsConfigurationHelpers';
import Authorization from '@appComponents/Authorization';
import LinkWithAuthorization from '@appComponents/LinkWithAuthorization';
import Table from '@appComponents/Table';

const authorizationEncodingTargetReadUpdateObject = {
    [ENCODING_TARGET]: SECURITY_PRIVILEGES_READ_UPDATE,
};

const vtdTunnelStatus = (row) => {
    if (!row.is_placeholder_for_auto_assignment) {
        return row.vtdTunnel?.started ? 'Started' : 'Stopped';
    }

    return '';
};

export const columns = {
    'client': {
        label: 'Client',
        sorting: (row) => (row.client.name),
        ...columnObjectAlignLeft,
    },
    'tunnel': {
        label: 'Tunnel',
        sorting: (row) => (row.name),
        ...columnObjectAlignLeft,
    },
    'vtdTunnelStatus': {
        label: 'VTD tunnel status',
        sorting: (row) => (vtdTunnelStatus(row)),
        ...columnObjectAlignCenter,
    },
    'encodingTarget': {
        label: 'Encoding target',
        sorting: (row) => (row.encoding_target_id),
        ...columnObjectAlignCenter,
    },
    'actions': {
        label: 'Actions',
        ...columnObjectAlignCenter,
    },
};

export const EventsConfigurationThirdPartyTunnelerPushTable = (props) => {
    const {loading, encodingTargetsTunnels, vtdTunnels} = props;

    const rowRenderer = (column, row) => {
        switch (column) {
            case 'client':
                return (
                    <LinkWithAuthorization
                        link={{
                            name: 'clients.edit',
                            params: {
                                id: row.client?.id,
                            },
                        }}
                        privileges={SECURITY_PRIVILEGES_UPDATE}
                        resources={CLIENT}
                    >
                        {row?.client?.name}
                    </LinkWithAuthorization>
                );
            case 'tunnel':
                return row.vtd_tunnel_id && row.vtdTunnel
                    ? <Popup
                        content={row.vtd_tunnel_id ? `VTD: ${row.vtdTunnel.name} (${row.vtdTunnel.id})` : null}
                        position='top left'
                        trigger={renderTunnelerLink(row)}
                    />
                    : renderTunnelerLink(row);
            case 'vtdTunnelStatus':
                if (!row.is_placeholder_for_auto_assignment) {
                    return <TunnelStatus isStarted={!!row.vtdTunnel?.started} />;
                }

                return '';
            case 'encodingTarget':
                return row.encoding_target_id;
            case 'actions':
                return (
                    <Authorization
                        authorization={authorizationEncodingTargetReadUpdateObject}
                    >
                        <div className='actions-list-icon'>
                            <IconDelete
                                size='large'
                                onClick={() => showDeleteThirdPartyTunnelerModal(encodingTargetsTunnels, row)}
                            />
                        </div>
                    </Authorization>
                );
            default:
                return null;
        }
    };

    return (
        <div className='event_configuration_thirdy_party_client_vod_storages_table'>
            <Table
                className='mini'
                columns={columns}
                data={parseTunnelerData(encodingTargetsTunnels, vtdTunnels)}
                loading={loading}
                name='eventConfigurationThirdPartyTunnelerPushList'
                noDataText='No third party tunnelers defined.'
                noMessageBox
                pagination={false}
                rowRenderer={rowRenderer}
            />
        </div>
    );
};

EventsConfigurationThirdPartyTunnelerPushTable.propTypes = {
    loading: PropTypes.bool.isRequired,
    encodingTargetsTunnels: PropTypes.array,
    vtdTunnels: PropTypes.array,
};

export default EventsConfigurationThirdPartyTunnelerPushTable;
